import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api, ApiResponse, DataRequestOption } from '@app/infrastructure/data-list/grid/api-grid/api';
import { IApiListFilters } from '@app/infrastructure/data-list/table/table.model';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { CommitmentListService } from '@modules/potential-save-modal/commitment-list/commitment-list.service';
import {
	ICommitmentDTO,
	ICommitmentFilters,
	ICommitmentTableDTO,
} from '@modules/potential-save-modal/commitment-list/commitment.model';
import { isFalsy } from '@utils/is-falsy.tool';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class CommitmentListApiService implements Api<ICommitmentDTO, ICommitmentFilters> {
	constructor(private apiFacade: ApiFacadeService, private commitmentListService: CommitmentListService) {}

	public get(request: DataRequestOption<ICommitmentFilters>): Observable<ApiResponse<ICommitmentDTO>> {
		const url: string = 'potential-savings-v2/commitments-table';
		const offset = request.limit * (request.page - 1);
		let params: HttpParams = new HttpParams().set('limit', request.limit.toString()).set('offset', offset.toString());

		// @ts-ignore
		params = this.filterBuilder(request.filters, params);

		if (!!request.sortColumn?.columnName) {
			params = params
				.set('order_by', request.sortColumn.columnName)
				.set('direction_order', request.sortColumn.sortOrder);
		}

		return this.apiFacade.get<ICommitmentTableDTO>(url, { params }).pipe(
			tap((response) => {
				if (request.filters.expired) {
					this.commitmentListService.updateCommitmentTotal(response.commitmentsTotals.expired);
				} else {
					this.commitmentListService.updateCommitmentTotal(response.commitmentsTotals.notExpired);
				}
			}),
			map((response) => response.commitments),
		);
	}

	public exportCsv(): Observable<string> {
		const url: string = 'potential-savings-v2/export-commitments-csv';

		// @ts-ignore
		return this.apiFacade.get(url, { responseType: 'text' });
	}

	private filterBuilder(filters: IApiListFilters<ICommitmentFilters>, params: HttpParams): HttpParams {
		for (const filtersKey in filters) {
			if (
				(typeof filters[filtersKey] === 'string' && !isFalsy(filters[filtersKey])) ||
				(typeof filters[filtersKey] === 'boolean' && filters[filtersKey] !== false)
			) {
				params = params.set(filtersKey, `${filters[filtersKey]}`);
			}
		}

		return params;
	}
}
